<template>
  <el-form-item label="模板选择" prop="content" :rules="[{ required: true, message: '请选择模板', trigger: 'change' }]">
    <el-select 
      v-model="selectedTemplateId" 
      placeholder="请选择模板"
      @change="handleChange"
    >
      <el-option
        v-for="item in templateList"
        :key="item.id"
        :label="item.title"
        :value="item.id"
      />
    </el-select>
  </el-form-item>
</template>

<script>
import { ref, watch } from 'vue'

export default {
  props: {
    modelValue: {
      required: true
    },
    templateList: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const selectedTemplateId = ref(props.modelValue)

    watch(() => props.modelValue, (newVal) => {
      selectedTemplateId.value = newVal
    })

    const handleChange = (value) => {
      emit('update:modelValue', value)
    }

    return {
      selectedTemplateId,
      handleChange
    }
  }
}
</script>
